import { ReservationDTO } from 'api/controllers/reservations';
import { OrderDetails, OverdudedOrder } from 'store/ordersStore/reducer';

/**
 * Events from signal
 */
export enum SignalREvent {
    OrdersCountChanged = 'OrdersCountChanged',
    OrderChanged = 'OrderChanged',
    OrderAdded = 'OrderAdded',
    OverdudedOrdersChanged = 'OverdudedOrdersChanged',
    ReservationAdded = 'ReservationAdded',
    ReservationChanged = 'ReservationChanged',
}

/**
 * Map of event names to payload types
 */
export interface SignalREventsMap {
    OrdersCountChanged: number;
    OrderChanged: OrderDetails;
    OrderAdded: OrderDetails;
    OverdudedOrdersChanged: OverdudedOrder[];
    ReservationAdded: ReservationDTO;
    ReservationChanged: ReservationDTO;
}

export type SignalREventName = keyof SignalREventsMap;
